/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Short_Code_ResolvingInputs */



/**
* | output |
* | --- |
* | "Looking up the event…" |
*
* @param {Short_Code_ResolvingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const short_code_resolving = /** @type {((inputs?: Short_Code_ResolvingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Short_Code_ResolvingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recherche du tournoi…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscando el torneo…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Procurando o torneio…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricerca del torneo…")
	return /** @type {LocalizedString} */ ("Looking up the event…")
});